// src/App.js

import React from "react";
import { Routes, Route } from "react-router-dom";
import { MsalProvider } from "@azure/msal-react";
import { msalInstance } from "./components/auth/authConfig"; // MSAL instance
import Login from "./components/auth/SigninWidget"; // Your login component
import useAutoLogout from "./components/auth/AutoLogout";
import UserManagement from "./components/pages/UserManagement";
import Audit from "./components/pages/Audit";
import SendBack from "./components/pages/SendBack";
import Questions from "./components/pages/Questions";
import AuditForm from "./components/pages/AuditForm";
import OptionsAdditions from "./components/pages/OptionsAdditions";

const App = () => {
  useAutoLogout(); // Automatically logs out after 60 minutes of inactivity

  return (
    <MsalProvider instance={msalInstance}>
      <Routes>
        <Route path="/" element={<Login />} /> {/* Home route */}
        <Route path="/audit/form" element={<Audit />} />{" "}
        {/* Audit form route */}
        <Route path="/sendback/form" element={<SendBack />} />{" "}
        {/* Sendback form route */}
        <Route path="/admin/membercontrol" element={<UserManagement />} />{" "}
        <Route path="/admin/questions" element={<Questions />} />{" "}
        <Route path="/form" element={<AuditForm />} />{" "}
        <Route path="/admin/options" element={<OptionsAdditions />} />{" "}

        {/* User management route */}
      </Routes>
    </MsalProvider>
  );
};

export default App;
